import React, { useState, useEffect } from 'react';

import cls from 'classnames';

import noop from 'lodash/noop';

import { useLayoutContext } from '@ott/layout-context';
import Modal from '@ott/modal';

import styles from './IFrameModal.scss';

type Props = {
  isOpen: boolean;
  src?: string;
  name?: string;
  onClose: VoidFunction;
  className?: string;
  isWebview?: boolean;
  onMessage?: (message: MessageEvent) => void;
  defaultSize: {
    width: number;
    height: number;
  };
  isHidden?: boolean;
};

const IFrameModal = ({
  isOpen,
  src,
  onClose,
  onMessage = noop,
  defaultSize,
  name = '',
  className = '',
  isWebview = false,
  isHidden = false,
}: Props) => {
  const { isMobileLayout, viewportWidth, viewportHeight } = useLayoutContext();
  const initialSize = isMobileLayout
    ? {
        width: viewportWidth,
        height: viewportHeight,
      }
    : defaultSize;
  const [size, setSize] = useState(initialSize);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { type, message } = event.data;
      if (onMessage) {
        onMessage(event);
      }
      if (type === 'size' && message && !isMobileLayout) {
        setSize(message);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onMessage]);

  const modalChildren = {
    body: (
      <iframe
        className={styles.wrapper}
        src={src}
        name={name}
        width={size.width}
        height={size.height}
        title="details"
      />
    ),
  };

  return (
    <Modal
      isOpen={isOpen}
      fullScreenOnMobile={true}
      className={cls({ [styles.hidden]: isHidden })}
      contentOptions={{
        className: cls(styles.content, className, { [styles.webview]: isWebview }),
        childrenClassNames: {
          header: styles.header,
          closer: styles.closer,
          body: styles.body,
        },
      }}
      onClose={onClose}
      specificLocators="iframe-modal"
    >
      {modalChildren}
    </Modal>
  );
};

export default IFrameModal;
